<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
    >
      <v-card-text>
        <div>{{textoCatalogoDistribucionTerritorial}}</div>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col v-if="isEstado" cols="12" md="4" >
            <select-estado :id-estado-prop="idEstado" :fn-change="setEstado" :requerido="false" :consulta="consulta"></select-estado>
          </v-col>
          <v-col v-if="isCiudad" cols="12" md="4">
            <select-ciudad :id-estado="idEstado" :id-ciudad-prop="idCiudad" :fn-change="setCiudad" :requerido="false" :consulta="consulta"></select-ciudad>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: 'CatDistEncuesta',
  components: {
    SelectEstado: () => import("../comunes/SelectEstado"),
    SelectCiudad: () => import("../comunes/SelectCiudad"),
         
  },
  props: {
    isEstado: {
      type: Boolean,
      default: false
    },
    idEstado: {
      type: Number,
      default: null
    },
    setEstado: {
      type: Function,
      required: true
    },
    isCiudad: {
      type: Boolean,
      default: false
    },
    idCiudad: {
      type: Number,
      default: null
    },
    setCiudad: {
      type: Function,
      required: true
    },
    consulta: {
      type: Boolean,
      required: true
    },
    vistaPrevia: {
      type: Boolean,
      default: false
    },
    textoCatalogoDistribucionTerritorial:{
      type: String,
      default: null
    },
  },
  data: () => ({
    snackbar: false,
    snackbarColor: '',
    snackbarTexto: '',
  }),
  computed: {
    mdOffsetEstado: function () {
      var value = "4";
      if(this.isCiudad == true ){
        value = "2";
      }
      return value;
    }
  },
  watch: { },
  beforeMount() {
    console.log("ID ESTADO" + this.idEstado);
  },
  methods: {
    
  },
};
</script>